<template>
	<label class='input c-input'

	>
		<input type='text'
			v-if='vmask'
			ref='inp'
			class='input__field'
			:class='{"is-error": error || touched && (required?(value.length === 0?requiredField:"" ):"")}'
			v-mask='vmask'
			:value='modelGet'
			@input='modelSet'
			@blur='blurHandle'
			@focus='cursoutToEnd($event)'
			:readonly='!readonly'
			:autocomplete='(autocomplete)?("on"):("off")'
			:placeholder='placeholder'
		>
		<input type='text'
			v-else-if='imask'
			ref='inp'
			class='input__field'
			:class='{"is-error": error || touched && (required?(value.length === 0?requiredField:"" ):"")}'
			:value='modelGet'
			v-imask='mask({mask: imask})'
			@accept='modelSet'
			@blur='blurHandle'
			@input='()=>{touched = true}'
			@focus='cursoutToEnd($event)'
			:readonly='!readonly'
			:autocomplete='(autocomplete)?("on"):("off")'
			:placeholder='placeholder'
		>
		<input
			v-else
			class='input__field'
			:class='{"is-error": error || touched && (required?(value.length === 0?requiredField:"" ):"")}'
			:value='modelGet'
			@input='modelSet'
			:type='type'
			:readonly='!readonly'
			@blur='blurHandle'
			@focus='cursoutToEnd($event)'
			:autocomplete='(autocomplete)?("on"):("off")'
			:placeholder='placeholder'
		>
		<span
			class='input__labels'
			:data-label='label'
			:data-error='error || requiredField'
		></span>
		<svg class='icon' v-if='icon'>
			<!-- <use xlink:href='#{{ icon }}'/> -->
		</svg>

		<!-- tooltip info -->
		<svg class='icon tooltip' :data-tippy-content='help_text'>
			<!-- <use xlink:href='#icon-info'/> -->
		</svg>
	</label>
</template>

<script>
import mask from '__jsLibs/mask';
import { IMaskDirective } from 'vue-imask';
import '../../../../../../assets/css/login.css';
export default {
	props: {
		label: {
			type:    String,
			default: ''
		},
		error: {
			type:    String,
			default: ''
		},
		icon: {
			type:    String,
			default: ''
		},
		help_text: {
			type:    String,
			default: ''
		},
		vmask: {
			type:    String,
			default: ''
		},
		imask: {
			type:    String,
			default: ''
		},
		value: {
			type:    [String, Number],
			default: ''
		},
		required: {
			type:    Boolean,
			default: false
		},
		type: {
			type:    String,
			default: 'text'
		},
		readonly: {
			type:    Boolean,
			default: true
		},
		autocomplete: {
			type:    Boolean,
			default: true
		},
		placeholder: {
			type:    String,
			default: ''
		}
	},
	data() {
		return {
			mask:          mask,
			requiredField: 'Field Is Required',
			touched:       false
		};
	},
	computed: {
		modelGet() {
			let val = this.value;
			if (this.$refs.inp && this.imask) {
				if (this.imask === 'num') {
					let price = this.formatPrice(Number(val));
					if (!/%/.test(price)) {
						val = `${price}`;
					}
				}
				if (this.imask === 'percent') {
					if (!/%/.test(val)) {
						val = `${val} %`;
					}
				}
				if (this.imask === 'price') {
					let price = this.formatPrice(Number(val));
					if (!/%/.test(price)) {
						val = `$ ${price}`;
					}
				} if (this.imask === 'phone') {
					this.formatNumber(val);
					// val = '(' + x[1] + ') ' + x[2] + '-' + x[3];
				}
			}
			return val;
		}
	},
	methods: {
		blurHandle() {
			this.touched = true;
			this.$emit('blur');
		},
		cursoutToEnd(e) {
			let el = e.target;
			setTimeout(() => {
				if (typeof el.selectionStart === 'number') {
					if (this.imask === 'percent') {
						el.selectionStart = el.selectionEnd = el.value.length - 2;
					}
					else {
						el.selectionStart = el.selectionEnd = el.value.length;
					}
				}
				else if (typeof el.createTextRange !== 'undefined') {
					el.focus();
					var range = el.createTextRange();
					range.collapse(false);
					range.select();
				}
			}, 100);
			this.$emit('focus');
		},
		formatPrice(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		},
		formatNumber(x) {
		},
		emit(data, maskRef) {
			if (maskRef) {
				maskRef.updateValue(data);
			}
			this.$emit('input', data);
		},
		modelSet(e) {
			this.touched = true;
			let data;
			if (this.imask) {
				const maskRef = e.detail;
				data = maskRef.value.replace(/[$%,]/g, '').replace(/\s/g, '');
				// data = maskRef.value;
				if (this.imask === 'price' || this.imask === 'percent') {
					if (data === '0100') {
						this.emit(0, maskRef);
					}
					else {
						this.emit(Number(data), maskRef);
					}
				}
				if (this.imask === 'num') {
					if (data === '0100') {
						this.emit(0, maskRef);
					}
					else {
						this.emit((data) ? (Number(data)) : (null), maskRef);
					}
				}
			}
			else {
				data = e.target.value;
				this.emit((this.type === 'number') ? ((data) ? (Number(data)) : (null)) : (data));
			}
		},
	},
	directives: {
		imask: IMaskDirective
	},
};
</script>
